export default "__VITE_ASSET__afc788c6__"